function formatDateAndAge(dateString) {
  // Parse the date string
  const dob = new Date(dateString);

  // Current date
  const currentDate = new Date();

  // Calculate the age
  const ageDate = new Date(currentDate - dob);
  const years = ageDate.getUTCFullYear() - 1970;
  const months = ageDate.getUTCMonth();
  const days = ageDate.getUTCDate() - 1; // Subtracting 1 to exclude the current day

  // Format the date of birth
  const formattedDob = dob.toLocaleDateString("en-GB"); // Change the locale as needed

  // Format the age
  const formattedAge = `${years} Years ${months} Months ${days} Days`;

  // Format the current date
  const formattedCurrentDate = currentDate.toISOString().slice(0, 10); // Get the date part only

  return `${formattedDob} (${formattedAge} on ${formattedCurrentDate})`;
}

export default formatDateAndAge;
